import React from "react";
import { Layout, Typography } from "antd";
import AuthorCard from "../AuthorCard";

const { Content } = Layout;
const { Title } = Typography;
const Home = () => {
  return (
    <Content style={{ padding: "24px" }}>
      <Title level={1}>About Us</Title>
      <AuthorCard />
    </Content>
  );
};

export default Home;
